export const TESTIDS = {
  // Nav
  navHome: "nav-home-link",
  navLogin: "nav-login-link",
  navSignup: "nav-signup-link",
  navLogout: "nav-logout-button",
  navDashboard: "nav-dashboard-link",

  // Landing
  heroCtaReading: "hero-cta-enter-reading",
  heroCtaNotTested: "hero-cta-not-tested",

  // Auth
  authNameInput: "auth-name-input",
  authEmailInput: "auth-email-input",
  authPasswordInput: "auth-password-input",
  authSubmit: "auth-submit-button",
  authError: "auth-error-message",
  authSwitch: "auth-switch-link",

  // Dashboard / property
  propertyStreetInput: "property-street-input",
  propertyCityInput: "property-city-input",
  propertyStateInput: "property-state-input",
  propertyZipInput: "property-zip-input",
  propertySaveBtn: "property-save-button",
  propertyEditBtn: "property-edit-button",
  propertyCard: "property-card",

  // Journey
  journeyStepper: "journey-stepper",
  journeyStep: "journey-step",

  // Reading form
  readingForm: "reading-form",
  readingPciL: "reading-pci-l-input",
  readingDate: "reading-date-input",
  readingLocation: "reading-location-select",
  readingDevice: "reading-device-select",
  readingKind: "reading-kind-select",
  readingNotes: "reading-notes-input",
  readingSubmit: "reading-submit-button",

  // Result / latest
  latestReadingCard: "latest-reading-card",
  latestReadingValue: "latest-reading-value",
  latestReadingLevel: "latest-reading-level",
  latestReadingHeadline: "latest-reading-headline",
  latestReadingSummary: "latest-reading-summary",
  epaLink: "epa-radon-zones-link",

  // Action plan
  actionPlan: "action-plan",
  actionPlanItem: "action-plan-item",

  // History
  historyList: "reading-history-list",
  historyItem: "reading-history-item",

  // Assistance callout
  cr3Callout: "cr3-assistance-callout",
};
